export default __webpack_public_path__ + "static/media/minimog.5fbdf0b4.png";